<small class="price-metadata">
  {{
    $metadata()
      | transloco
      | concat
        : ' • '
        : ('cartridge.billingPeriod.' + price().billingPeriod | transloco)
  }}
</small>
